export default __webpack_public_path__ + "static/media/nfm.258e4495.jpeg";